define([
    "skylark-utils/styler"
], function(styler) {
    return styler;
});
